import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import LabTestTemplateBody from "components/AdministrationComponents/LabTestTemplates/LabTestTemplateBody";

const LabTestTemplates = () => {
  useEffect(() => {
    document.title = "Administration | Lab Test Templates";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="administration" />
      <LabTestTemplateBody />
    </main>
  );
};

export default LabTestTemplates;
